module.exports = __webpack_public_path__ + "img/unit2-mechanical.0d40f44e.svg";